import { Skeleton } from "@mantine/core"

export function NavbarOptionSkeletonButton() {
  return <Skeleton height={36} width={36} radius={"md"} opacity={0.3} />
}
